import { connect } from 'react-redux';
import { Card, Row } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import PropertyDropdown from './components/PropertyDropdown';
import BaseFeature from './BaseFeature';
import { SOFT_SWITCH_OFF } from '../../../../../../utils/constantFeatures';

class SoftSwitchOff extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[SOFT_SWITCH_OFF.enable].value === "1" ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        this.props.handleChange(propertyName, v);

        if (this.getCorrectPropertyName(propertyName) === SOFT_SWITCH_OFF.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    render() {

        const ssoEn = this.props.properties[SOFT_SWITCH_OFF.enable];
        const ssoTi = this.props.properties[SOFT_SWITCH_OFF.time];

        return (
            <div>
                <Card className={this.getClassName([ssoEn, ssoTi])}>
                    <div className="card-header-feature">
                        {'Soft Switch Off'}
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <PropertySwitch
                            property={ssoEn}
                            title={ssoEn.info.displayName}
                            handleChange={this.handleChange} />

                        {/* <PropertyPicker
                            disabled={!this.state.isEnabled}
                            property={ssoTi}
                            inputPadding={'padding-none'}
                            title={ssoTi.info.displayName}
                            measureUnit={'s'}
                            min={ssoTi.valueMeta.min}
                            max={ssoTi.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} /> */}

                        <Row style={{ display: 'flex', flexDirection: 'row', margin: '0.75rem auto 0px' }}>
                            <PropertyDropdown
                                disabled={!this.state.isEnabled}
                                paddingTitle={'0'}
                                margin={'0.75rem auto 0'}
                                property={ssoTi}
                                properties={ssoTi.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                propertyDisplayFunc={(res) => res}
                                title={'Time'}
                                handleChange={this.handleChange} />
                            <div style={{ margin: 'auto', marginLeft: '2rem' }}>{ssoTi.info.unit}</div>
                        </Row>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SoftSwitchOff);
